// eslint-disable-next-line import-x/prefer-default-export
export const columns = [
  {
    name: 'id',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'exchangeCurrencyFixedId',
    label: 'Exchange Type',
  },
  {
    name: 'exchangeCurrencyFromId',
    label: 'Sell',
  },
  {
    name: 'sum',
    label: 'Amount Sell',
  },
  {
    name: 'exchangeCurrencyToId',
    label: 'Buy',
  },
  {
    name: 'exchangeCurrencyFlexibleSum',
    label: 'Amount Buy',
  },
  {
    name: 'senderAccountNumber',
    label: 'From Account',
  },
  {
    name: 'recipientAccountNumber',
    label: 'To Account',
  },
];
